module.exports = __webpack_public_path__ + "img/Physical_Game_Session.197e69c7.png";